import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { End, Form, Loader, Start } from 'components/Questionnaire';
import { openSnackbar } from 'store/application';
import useDailySurvey from 'hooks/useDailySurvey';

const PulseSurvey = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [started, setStarted] = useState(false);

  const {
    form,
    completed,
    startScreenData,
    celebrationScreenData,
    isDailySurveyLoading,
    isTaskDetailsLoading,
    handleSubmit,
  } = useDailySurvey({
    onSubmit : () => {
      dispatch(
        openSnackbar({
          type    : 'success',
          message : 'Daily survey answers submitted',
        })
      );
      setStarted(false);
    },
    onSubmitError : () =>
      dispatch(
        openSnackbar({
          type    : 'error',
          message : 'Could not save your PULSE survey answers. Please try again',
        })
      ),
    onLoadError : () =>
      dispatch(
        openSnackbar({
          type    : 'error',
          message : 'Could not load the PULSE survey.',
        })
      ),
  });

  const handleStart = () => setStarted(true);

  const handleExit = () => navigate('/homepage');

  const isLoading = isDailySurveyLoading || isTaskDetailsLoading;

  if (isLoading) return <Loader />;
  if (completed) return <End
    onEnd={handleExit} data={celebrationScreenData}
  />;
  if (!started) return <Start
    onStart={handleStart} data={startScreenData}
  />;
  return (
    <Form
      form={form}
      onSubmit={handleSubmit}
      onCancel={handleExit}
      readOnly={false}
    />
  );
};

export default PulseSurvey;
